module.exports = __webpack_public_path__ + "static/img/makasini-heamasi.e890064.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/makasini-heamasi.jpg
// module id = Jt4I
// module chunks = 0